module.exports = __webpack_public_path__ + "img/confirmation-tests-active.a4d6f490.svg";